var _rect, _rect2, _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutorials(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 608.5 533.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.7,
    y: 128.1,
    width: 157.9,
    height: 20.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 372.9,
    y: 128.1,
    width: 157.9,
    height: 20.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456.3,282.5c3.2,6.7,6,13.6,8.4,20.8h66.2v-20.8h-74.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.8,301.1l84.1,49.2c4.9,2.9,4.8,9.9-.1,12.7l-84.1,46.6c-4.9,2.7-10.8-.8-10.8-6.4v-95.9c-.1-5.5,6-9,10.9-6.2Z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 304.2,
    cy: 355.4,
    r: 168.4,
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380,205c11.4,5.7,22,12.7,31.7,20.8h119.1v-20.8h-150.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.4,282.5H79.7v20.8h64.4c2.3-7.1,5.1-14.1,8.3-20.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5,205H79.7v20.8h117.1c9.7-8.1,20.3-15.1,31.7-20.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M354.2,10c-27.61,0-50,22.39-50,50v127c93,0,168.4,75.4,168.4,168.4,0,10.61-.98,20.98-2.85,31.05-2.39,12.83,7.53,24.65,20.57,24.65h108.17V30.25c0-11.18-9.07-20.25-20.25-20.25h-224.05Z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.9,355.4c0-86.99,65.98-158.59,150.62-167.47,10.13-1.06,17.78-9.69,17.78-19.87V80c0-38.66-31.34-70-70-70H30c-11.05,0-20,8.95-20,20V391c0,11.05,8.95,20,20,20H119.26c12.48,0,22.04-11.32,19.68-23.58-1.99-10.36-3.04-21.07-3.04-32.02Z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorials);
export default __webpack_public_path__ + "static/media/tutorials.21351062.svg";
export { ForwardRef as ReactComponent };